<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 页头 -->
      <div class="page-card__header">
        <span style="padding-right: 20px"> 展会资料下载</span>
        <el-button type="primary" round size="small" @click="addTotalVisible = true">上传资料</el-button>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%; padding: 0 20px">
        <el-table-column prop="title" label="资料名" width="200">
        </el-table-column>
        <el-table-column prop="type" label="分类" width="100">
        </el-table-column>
        <el-table-column prop="desc" label="简介描述"> </el-table-column>
        <el-table-column prop="upload_time" label="上传时间" width="200">
        </el-table-column>
        <el-table-column prop="download" label="下载" width="160">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              round
              @click="go_download(scope.row.filename, scope.row.title)"
              >下载</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleClick(scope.row)"
              >修改</el-button>
            <el-button
              type="text"
              class="action-btn--danger"
              @click="deleteFile(scope.row)"
              >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 弹窗 - 上传资料 -->
    <el-dialog
      title="上传资料"
      :visible.sync="addTotalVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form label-width="100px" ref="form" :model="form" :rules="rules">
        <el-form-item label="资料名" style="text-align: left" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="分类" style="text-align: left" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">类型一</el-radio>
            <el-radio :label="2">类型二</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="资料描述" prop="desc">
          <el-input type="textarea" v-model="form.desc" rows="4"></el-input>
        </el-form-item>
        <el-form-item style="text-align: left" prop="filename">
          <el-upload
            class="avatar-uploader"
            :action="filesrc"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :headers="headers"
            :before-upload="beforeAvatarUpload"
          >
            <el-button size="small" type="primary" style="text-align: left">点击上传资料</el-button>
            <span v-if="form.filename !== ''"
              >上传文件：<span style="color: var(--color-primary)">{{ form.filename }}</span>
            </span>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" round size="small" @click="submitFile('form')">确认提交</el-button>
          <el-button round size="small" @click="addTotalVisible = false">取消修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 弹窗 - 修改资料 -->
    <el-dialog
      title="修改资料"
      :visible.sync="updateTotalVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form label-width="100px" ref="uploadForm" :model="uploadForm" :rules="rules">
        <el-form-item label="资料名" style="text-align: left" prop="title">
          <el-input v-model="uploadForm.title"></el-input>
        </el-form-item>
        <el-form-item label="分类" style="text-align: left" prop="type">
          <el-radio-group v-model="uploadForm.type">
            <el-radio label="1">类型一</el-radio>
            <el-radio label="2">类型二</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="资料描述" prop="desc">
          <el-input type="textarea" v-model="uploadForm.desc" rows="4"></el-input>
        </el-form-item>
        <el-form-item style="text-align: left" prop="filename">
          <el-upload
            class="avatar-uploader"
            :action="filesrc"
            :show-file-list="false"
            :on-success="handleAvatarSuccess_u"
            :headers="headers"
            :before-upload="beforeAvatarUpload"
          >
            <el-button size="small" type="primary" style="text-align: left">点击上传资料</el-button>
            <span v-if="uploadForm.filename !== ''"
              >上传文件：<span style="color: var(--color-primary)">{{ uploadForm.filename }}</span>
            </span>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" round size="small" @click="submitFile_up('uploadForm')">确认修改</el-button>
          <el-button round size="small" @click="updateTotalVisible = false">取消修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "eventDownload",
  data() {
    return {
      updateTotalVisible: false,
      addTotalVisible: false,
      k_id: "",
      form: {
        title: "",
        desc: "",
        type: "",
        filename: "",
      },
      uploadForm: {
        title: "",
        desc: "",
        type: "",
        filename: "",
      },
      rules: {
        title: [{ required: true, message: "请输入资料名", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        desc: [{ required: true, message: "请选择类型", trigger: "blur" }],
        filename: [{ required: true, message: "请选择文件", trigger: "blur" }],
      },
      tableData: [],
      // 总条目数
      aSum: 100,
      // 当前页数
      currentPage: 1,
      // 总页数
      pageCount: 10,
      // 每页显示条目数
      pagesize: 10,
      headers: { Authorization: "JWT " + localStorage.getItem("adminToken") },
      filesrc: this.baseUrl + "/admin/uploadfile/file/",
      fileUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/file/",
    };
  },
  mounted() {
    // 获取资料下载列表
    this.downloadList();
  },
  methods: {
    // 下载文件
    go_download(filename, filetitle) {
      const x = new window.XMLHttpRequest();
      x.open("GET", this.fileUrl + filename, true);
      x.responseType = "blob";
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = filetitle;
        a.click();
      };
      x.send();
    },

    // 获取资料下载列表
    downloadList() {
      let url = this.baseUrl + "/admin/files/";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 切换分页
    handleCurrentChange(val) {
      let url = this.baseUrl + "/admin/files/?page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 提交上传资料
    submitFile(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let url = this.baseUrl + "/admin/files/";
          api.postData(url, {
            title: this.form.title,
            type: this.form.type,
            desc: this.form.desc,
            filename: this.form.filename,
          }).then((res) => {
            this.$message({
              message: "资料上传成功",
              type: "success",
            });
            this.addTotalVisible = false;
            this.downloadList();
          });
        }
      });
    },

    // 提交修改资料
    submitFile_up(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let url = this.baseUrl + "/admin/files/" + this.k_id + "/";
          api.patchData(url, {
            title: this.uploadForm.title,
            type: this.uploadForm.type,
            desc: this.uploadForm.desc,
            filename: this.uploadForm.filename,
          }).then((res) => {
            this.$message({
              message: "资料修改成功",
              type: "success",
            });
            this.updateTotalVisible = false;
            this.downloadList();
          });
        }
      });
    },

    // 文件上传成功回调
    handleAvatarSuccess(res, file) {
      let imageUrl = URL.createObjectURL(file.raw);
      this.form.filename = res.filename;
    },

    // 文件上传成功回调（修改表单）
    handleAvatarSuccess_u(res, file) {
      let imageUrl = URL.createObjectURL(file.raw);
      this.uploadForm.filename = res.filename;
    },

    // 文件上传前校验
    beforeAvatarUpload() {},

    // 查看资料详情（进入编辑）
    handleClick(row) {
      let id = row.id;
      this.k_id = row.id;
      let url = this.baseUrl + "/admin/files/" + id + "/";
      api.fetchData(url).then((res) => {
        this.uploadForm = res;
        this.updateTotalVisible = true;
      });
    },

    // 删除资料
    deleteFile(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = row.id;
        let url = this.baseUrl + "/admin/files/" + id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.downloadList();
        });
      });
    },
  },
  components: {
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/eventDownload.vue